module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 59
// module chunks = 1 2 3 4